import { Link, router, usePage } from "@inertiajs/react"
import { Building2, Check, ChevronsUpDown, Plus } from "lucide-react"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar"
import { useIsMobile } from "@/hooks/use-mobile"
import { currentTeamPath, newTeamPath } from "@/routes"
import type { SharedProps, Team } from "@/types"

export function TeamSwitcher() {
  const { auth } = usePage<SharedProps>().props
  const { teams, current_team } = auth
  const { state } = useSidebar()
  const isMobile = useIsMobile()

  function switchTeam(team: Team) {
    if (team.id === current_team?.id) return
    router.patch(currentTeamPath(), { team_id: team.id })
  }

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="text-sidebar-accent-foreground data-[state=open]:bg-sidebar-accent"
            >
              <div className="bg-sidebar-primary text-sidebar-primary-foreground flex aspect-square size-8 items-center justify-center rounded-lg">
                <Building2 className="size-4" />
              </div>
              <span className="truncate font-semibold">
                {current_team?.name ?? "Team"}
              </span>
              <ChevronsUpDown className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
            align="start"
            side={
              isMobile ? "bottom" : state === "collapsed" ? "right" : "bottom"
            }
          >
            {teams.map((team) => (
              <DropdownMenuItem key={team.id} onSelect={() => switchTeam(team)}>
                <span className="truncate">{team.name}</span>
                {team.id === current_team?.id && (
                  <Check className="ml-auto size-4" />
                )}
              </DropdownMenuItem>
            ))}
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <Link className="block w-full" href={newTeamPath()} prefetch>
                <Plus className="size-4" />
                Create New Team
              </Link>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
